import React from 'react';
import cx from 'classnames';

import {Text, FontVariant} from '@pexip/components';

import styles from './BreakoutRoomsNameAndTimeLeft.module.scss';

export const BreakoutRoomsNameAndTimeLeftView: React.FC<
    React.ComponentProps<'div'> & {
        meetingName?: string;
        roomName: string;
        timeLeft: string;
        isSmallText?: boolean;
        isTruncated?: boolean;
        headingTestId?: string;
    }
> = ({meetingName, roomName, timeLeft, headingTestId, isSmallText = false}) => (
    <>
        <Text
            fontVariant={isSmallText ? FontVariant.SmallBold : FontVariant.H5}
            className={cx(styles.roomName)}
            data-testid={headingTestId}
        >
            {meetingName ?? `/ `}
            {roomName}
        </Text>
        {timeLeft && (
            <Text
                className={cx('ml-2', styles.timeLeft, {
                    [styles.smallText]: isSmallText,
                })}
                fontVariant={isSmallText ? FontVariant.Body : FontVariant.H6}
            >
                {`/ ${timeLeft}`}
            </Text>
        )}
    </>
);

export type BreakoutRoomsNameAndTimeLeftViewProps = React.ComponentProps<
    typeof BreakoutRoomsNameAndTimeLeftView
>;
